import html2canvas from "html2canvas"

export default class Converter {
  static async fromHtmlToBase64Image(htmlElement) {
    const canvas = await html2canvas(htmlElement)
    const data = canvas.toDataURL('image/jpg')
    return data
  }
}